import React from "react";
import classNames from "classnames";
import { Card } from "@campgladiator/cgui-core.atoms.card";
import { Icon } from "@campgladiator/cgui-core.atoms.icon";
import { Label, Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { Button } from "@campgladiator/cgui-core.atoms.button";
import styles from "./PaymentMethods.module.scss";
import { toTitleCase } from "@campgladiator/cg-common.utility.strings";
import { DefaultPaymentMethod } from "@campgladiator/cg-common.api.stripe";

export type PaymentMethodsProps = {
  defaultPaymentDetails?: DefaultPaymentMethod[];
  onSelectPaymentMethodOption: (paymentMethod: DefaultPaymentMethod) => void;
  selectedPaymentMethod?: DefaultPaymentMethod;
  onAddNewCardClick: () => void;
};

const PaymentMethods = ({
  defaultPaymentDetails,
  onSelectPaymentMethodOption,
  selectedPaymentMethod,
  onAddNewCardClick,
}: PaymentMethodsProps) => (
  <div className={styles.container}>
    <Paragraph weight="bold" className={styles.headerLabel}>
      Select Payment Method
    </Paragraph>
    <div className={styles.cardContainer}>
      {defaultPaymentDetails?.map((paymentMethod) => (
        <Card
          key={paymentMethod.id}
          flat
          className={classNames(
            styles.item,
            paymentMethod.id === selectedPaymentMethod?.id && styles.selected
          )}
          onClick={() => onSelectPaymentMethodOption(paymentMethod)}
        >
          <div className={styles.content}>
            <div className={styles.icon}>
              <div>
                <Icon.Line name="icon-credit-card" />
              </div>
              {paymentMethod?.default && (
                <Label size="small" className={styles.default}>
                  DEFAULT
                </Label>
              )}
            </div>

            <div className={styles.detail}>
              <div className={styles.info}>
                <Paragraph className={styles.label} weight="book">
                  {toTitleCase(paymentMethod?.card?.brand || "")} card ending{" "}
                  {paymentMethod?.card?.last4 || ""}
                </Paragraph>
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
    <div>
      <Button
        onClick={onAddNewCardClick}
        size="small"
        emphasis="secondary"
        icon={{
          name: "icon-credit-card",
          type: "line",
        }}
      >
        Add new card
      </Button>
    </div>
  </div>
);

export default PaymentMethods;
